import React from 'react';
import Reveal from '@/components/site/Reveal';
import CountUp from '@/components/site/CountUp';

const STATS = [
  { value: 1, suffix: 'M+', label: 'Sq Ft Leasing Potential' },
  { value: 100, suffix: '+', label: 'Tenant Connections' },
  { value: 50, suffix: '+', label: 'Commercial Assets' },
  { value: 95, suffix: '%', label: 'Occupancy Focus' },
];

export default function Stats() {
  return (
    <section data-testid="home-stats" className="py-20 md:py-24 bg-slate-50">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-5 md:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 80}>
              <div data-testid="stats-counter-card" className="rounded-xl border border-slate-200 bg-white p-7 text-center md:text-left">
                <p className="font-display text-4xl md:text-5xl font-semibold text-[#144726] tracking-tight">
                  <CountUp to={s.value} suffix={s.suffix} />
                </p>
                <p className="mt-3 text-sm font-medium text-slate-600">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
